module.exports = __webpack_public_path__ + "static/media/mode23.1831c0a4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode23.gif
// module id = 1451
// module chunks = 110